import { Box, Button, IconButton } from "@mui/material";
import React from "react";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import MoneyIcon from "@mui/icons-material/Money";
import TollIcon from "@mui/icons-material/Toll";
import { useNavigate } from "react-router";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";

const AddSalesPage = () => {
    const navigate = useNavigate();
    const user = useAuthUser();
    console.log("User:", user);
    return (
        <Box
            sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-around",
                alignItems: "center",
            }}
        >
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <IconButton
                    onClick={() => navigate("/SelectCustomer?invoiceType=1")}
                >
                    <AccountBalanceIcon
                        style={{
                            width: "200px",
                            height: "200px",
                        }}
                    />
                </IconButton>
                إيصال مع ضريبة
            </div>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <IconButton
                    onClick={() => navigate("/SelectCustomer?invoiceType=2")}
                >
                    <MoneyIcon
                        style={{
                            width: "200px",
                            height: "200px",
                        }}
                    />
                </IconButton>
                إيصال بدون ضريبة
            </div>
            {[1, 2].includes(user.employeeType.id) && (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <IconButton
                        onClick={() =>
                            navigate("/SelectCustomer?invoiceType=3")
                        }
                    >
                        <TollIcon
                            style={{
                                width: "200px",
                                height: "200px",
                            }}
                        />
                    </IconButton>
                    مبيع شخصي
                </div>
            )}
        </Box>
    );
};

export default AddSalesPage;
